import { render } from "./right-content.vue?vue&type=template&id=62b606e3&ts=true"
import script from "./right-content.vue?vue&type=script&lang=ts"
export * from "./right-content.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__